import { render, staticRenderFns } from "./UiLoadCard.vue?vue&type=template&id=050981b8"
import script from "./UiLoadCard.vue?vue&type=script&lang=js"
export * from "./UiLoadCard.vue?vue&type=script&lang=js"
import style0 from "./UiLoadCard.vue?vue&type=style&index=0&id=050981b8&prod&lang=css"


/* normalize component */
import normalizer from "!D:\\projects\\xena\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports